// Utility function to add rowSpan for market_name
const groupByMarketName = (devices) => {
    const grouped = {};
    devices.forEach((device, index) => {
        const market = device.market_name;
        if (!grouped[market]) {
            grouped[market] = [];
        }
        grouped[market].push({...device, originalIndex: index});
    });

    const result = [];
    for (const market in grouped) {
        const group = grouped[market];
        group.forEach((item, idx) => {
            item.rowSpan = idx === 0 ? group.length : 0;
            item.showGroupIcon = idx === 0; // add this field to show icon only once per group
            result.push(item);
        });
    }

    return result;
};

export default groupByMarketName;
